export type TableRowSpacerProps = {
    totalCols: number,
    title: string
}

export function TableRowSpacer(props: TableRowSpacerProps) {
    return (<tr key={`HR_${props.title}`} className="header-row">
        <td className="p-2 ps-3 pe-3 ignoreHover no-highlight" colSpan={props.totalCols}>
            <div className="p-2 ps-3 pe-4 bg-grey">
                {props.title}
                <hr className="ShortBlock" />
            </div>
        </td>
    </tr>);
}